// components/common/ProtectedRoute.jsx
import { useContext, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../Navbar/AuthContext';

const ProtectedRoute = ({ allowedRoles = [],restrictedRoles = [] }) => {
  const { isAuthenticated, role, verifyAuth } = useContext(AuthContext);
  const location = useLocation();

  // Verify auth only once when route changes
  useEffect(() => {
    verifyAuth();
  }, [location.pathname, verifyAuth]);

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Check for restricted roles first
  if (restrictedRoles.includes(role)) {
    return <Navigate to="/creator-restricted-dashboard" replace />;
  }

  // if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
  //   return <Navigate to="/" replace />;
  // }

  return <Outlet />;
};

export default ProtectedRoute;